// extracted by mini-css-extract-plugin
var _1 = "PageActionsButtonAddEntity-modulebutton__QSLV4";
var _2 = "PageActionsButtonAddEntity-modulebuttonText__tZLV0";
export { _1 as "button", _2 as "buttonText" }
